import localeEn from "./localeEn.js";
import localeEs from "./localeEs.js";
import localePt from "./localePt.js";
const locales = {
    es: localeEs,
    pt: localePt,
    en: localeEn
};
const i18n = locales;
export default i18n;
